import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { Divider } from '../../../Divider'
import { useRequestProfileRatingActions } from '../../RequestProfile.hooks'

import {
  getRatingCardActions,
  isRatingCardEditAction,
} from './RequestProfileTabRatingCard.utils'
import { RequestProfileTabRatingCardBody } from './RequestProfileTabRatingCardBody'
import { RequestProfileTabRatingCardComments } from './RequestProfileTabRatingCardComments'
import { RequestProfileTabRatingCardHeader } from './RequestProfileTabRatingCardHeader'
import { RequestProfileTabRatingCardSkeleton } from './RequestProfileTabRatingCardSkeleton'

import * as styles from './RequestProfileTabRatingCard.module.css'

function RequestProfileTabRatingCard({ loading, ref, value = EMPTY_OBJECT }) {
  const { t } = useTranslation()

  const { handleOpenRating } = useRequestProfileRatingActions()

  function handleClickAction({ value: action }) {
    if (isRatingCardEditAction(action)) {
      handleOpenRating(value.uuid, value.permissions)
    }
  }

  const actions = getRatingCardActions({ permissions: value.permissions, t })

  return loading ? (
    <RequestProfileTabRatingCardSkeleton />
  ) : (
    <div className={styles.card} ref={ref}>
      <RequestProfileTabRatingCardHeader
        actions={actions}
        created={value.created}
        owner={value.owner}
        status={value.status}
        onClickAction={handleClickAction}
      />
      <Divider className={styles.divider} />
      <RequestProfileTabRatingCardBody value={value} />
      <Divider className={styles.divider} />
      <RequestProfileTabRatingCardComments value={value} />
    </div>
  )
}

export default RequestProfileTabRatingCard
